import type { Notice } from '@ps/web-martech-cms-types';
import type { StarsInfoType } from '@ps/web-shared-ui';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import { CMSHTML } from '@swf/cms';

import styles from './CMSNotice.scss';

const CMSNotice: React.FC<Notice> = ({ title, content, variant }) => (
  <StarsInfo type={variant as StarsInfoType} className={styles.notice}>
    {title && <strong>{title}</strong>}
    <CMSHTML content={content} />
  </StarsInfo>
);
export default CMSNotice;
